import PageUtils from '@/utils/page-utils';

export const globalMixin = {
  methods: {
    isMessagePanelOpen() {
      let element = document.querySelector('.message-panel');

      return getComputedStyle(element).bottom == '0px';
    }
  },
  computed: {
    $panelUrl() {
      if (PageUtils.isLocalhost()) {
        return 'http://localhost:8080/';
      }

      return this.$store.getters['CodementumUrl/panel'];
    }
  }
};
